import React from 'react';
import promotion_icon from './icons/promotion.svg';
import re_ordering_icon from './icons/re_ordering.svg';
import { get } from 'lodash';
import styled from 'styled-components';
import { Text } from '@fozito/common-ui';

export enum CashierProductHandleType {
  PROMOTION = 'PROMOTION',
  REORDERING = 'REORDERING',
}
const configs = {
  [CashierProductHandleType.PROMOTION]: {
    label: 'Promotion New',
    icon: promotion_icon,
  },
  [CashierProductHandleType.REORDERING]: {
    label: 'Re Ordering',
    icon: re_ordering_icon,
  },
};
type CashierProductHandleButtonProps = {
  type: CashierProductHandleType;
  onClick?: () => void;
  active?: boolean;
};
const CashierProductHandleButton = ({ type, onClick, active }: CashierProductHandleButtonProps) => {
  const config = get(configs, type);
  if (!config) return null;
  return (
    <Styled type='button' className={active ? 'active' : ''} onClick={onClick}>
      <img src={config.icon} style={{ width: 24, height: 24 }} />
      <Text content_content_3_16_semibold text_center color_text_5={!active} color_secondary_3={active}>{config.label}</Text>
    </Styled>
  );
};

export default CashierProductHandleButton;

const Styled = styled.button`
display: flex;
padding: 0px 24px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 4px;
height: 56px;
background: #E5F3E7;
box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;

&:hover,
  &:active {
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.1s;
  }

&:disabled {
  opacity: 0.7;
  &:hover,
  &:active {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
    transition: none;
  }
}

&.active {
  border-radius: 4px;
  border: 1px solid #2D6772;
  background: #FFF;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #144B55 inset;
}

`;